let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7YL1p")).then(() => parcelRequire('GquUU'));